export const iconFontAwesomeHumanitarianPersonDressBurst = (
	<i className="fa-solid fa-person-dress-burst"></i>
);
